import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import Administration from '@/components/Administration'
import ApiProcessLogGrid from '@/components/ApiProcessLogGrid'
import ApiKeyGrid from '@/components/ApiKeyGrid'
import TurnadoManual from '@/components/TurnadoManual'
import AdministrationTurnado from '@/components/AdministrationTurnado'
import PlanningGrid from '@/components/PlanningGrid'
import PlanningGridNew from '@/components/PlanningGridNew'
import TurnCurrSelect from '@/components/TurnCurrSelect'
import PlanningProvGrid from '@/components/PlanningProvGrid'
import PlanningProvGridNew from '@/components/PlanningProvGridNew'
import IncidentReport from '@/components/IncidentReport'
import MovimientosOC from '@/components/MovimientosOC'
import OCsinTurnos from '@/components/OCsinTurnos'
import UpdateTurn from '@/components/UpdateTurn.vue'
import PlanningProvDeleteGrid from '@/components/PlanningProvDeleteGrid'
import PlanningOpPointGrid from '@/components/PlanningOpPointGrid'
import RequestProposalModif from '@/components/RequestProposalModif'
import CreateEvent from '@/components/CreateEvent'
import ProductosInsumos from '@/components/ProductosInsumos'
import DeliveryCondition from '@/components/DeliveryCondition'
import PreOrderPurchase from '@/components/PreOrderPurchase'
import RepOrderForm from '@/components/RepOrderForm'
import RepOrderView from '@/components/RepOrderView'
import RepOrderAnswer from '@/components/RepOrderAnswer'
import BlockOC from '@/components/BlockOC'
import SupplierReceivingIssuesGrid from '@/components/SupplierReceivingIssuesGrid'
import Penalities from '../components/Penalities.vue'
import RepOrderPenalityAnswer from '../components/RepOrderPenalityAnswer.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:token',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/:token/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/:token/administration',
      name: 'Administration',
      component: Administration
    },
    {
      path: '/:token/administrationturnado',
      name: 'AdministrationTurnado',
      component: AdministrationTurnado
    },
    {
      path: '/:token/processlog',
      name: 'processlog',
      component: ApiProcessLogGrid
    },
    {
      path: '/:token/keysadmin',
      name: 'keysadmin',
      component: ApiKeyGrid
    },
    {
      path: '/:token/turnadomanual',
      name: 'turnadomanual',
      component: TurnadoManual
    },
    {
      path: '/:token/planning',
      name: 'PlanningGrid',
      component: PlanningGrid
    },
    {
      path: '/:token/TurnCurrSelect',
      name: 'TurnCurrSelect',
      component: TurnCurrSelect
    },
    {
      path: '/:token/PlanningProv',
      name: 'PlanningProvGrid',
      component: PlanningProvGrid
    },
    {
      path: '/:token/IncidentReport',
      name: 'IncidentReport',
      component: IncidentReport
    },
    {
      path: '/:token/MovimientosOC',
      name: 'MovimientosOC',
      component: MovimientosOC
    },
    {
      path: '/:token/OCsinTurnos',
      name: 'OCsinTurnos',
      component: OCsinTurnos
    },
    {
      path: '/:token/UpdateTurn',
      name: 'UpdateTurn',
      component: UpdateTurn
    },
    {
      path: '/:token/PlanningProvDelete',
      name: 'PlanningProvDeleteGrid',
      component: PlanningProvDeleteGrid
    },
    {
      path: '/:token/PlanningCentro',
      name: 'PlanningOpPointGrid',
      component: PlanningOpPointGrid
    },
    {
      path: '/:token/TurnModif',
      name: 'RequestProposalModif',
      component: RequestProposalModif
    },
    {
      path: '/:token/CreateEvent',
      name: 'CreateEvent',
      component: CreateEvent
    },
    {
      path: '/:token/ProductosInsumos',
      name: 'ProductosInsumos',
      component: ProductosInsumos
    }

    ,
    {
      path: '/:token/PlanningGridNew',
      name: 'PlanningGridNew',
      component: PlanningGridNew
    }
    ,
    {
      path: '/:token/PlanningProvGridNew',
      name: 'PlanningProvGridNew',
      component: PlanningProvGridNew
    },
    {
      path: '/:token/DeliveryCondition',
      name: 'DeliveryCondition',
      component: DeliveryCondition
    },
    {
      path: '/:token/PreOrderPurchase',
      name: 'PreOrderPurchase',
      component: PreOrderPurchase
    },
    {
      path: '/:token/RepOrderForm',
      name: 'CMPSolicitud',
      component: RepOrderForm
    },
    {
      path: '/:token/RepOrder/:id',
      name: 'RepOrder',
      component: RepOrderView
    },
    {
      path: '/RepOrder/:id/:proveedor',
      name: 'RepOrderAnswer',
      component: RepOrderAnswer
    },
    {
      path: '/:token/Penalities',
      name: 'OC Status',
      component: Penalities
    },
    {
      path: '/RepOrderPenality/:id/:pedido_id/:folio_id/:punto/:proveedor/:usuario',
      name: 'Respuesta PNS',
      component: RepOrderPenalityAnswer
    },
    {
      path: '/:token/BlockOC',
      name: 'BlockOC',
      component: BlockOC
    },
    {
      path: '/:token/SupplierReceivingIssuesGrid',
      name: 'SupplierReceivingIssuesGrid',
      component: SupplierReceivingIssuesGrid
    }    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js